<template>
    <div>
            <div
                class="table"
            >
                <!--<TablePreloader v-if="getLoader"/>-->


                <transition name="table-view">
                    <div class="table__empty d-flex justify-center align-center flex-column" v-if="!getLoader && tableData.data && !tableData.data.length">
                        <div class="table__empty-pic">
                            <img src="@/assets/images/table-empty.png" alt="">
                        </div>
                        <div class="table__empty-text">
                            {{emptyText}}
                        </div>
                    </div>
                    <div class="table__container" v-if="tableData.data && tableData.data.length">

                            <TableHead
                                    :table-head="tableHead"
                                    :moreMode="moreMode"
                                    :isMapOpen="isMapOpen"
                                    :allowTooltip="allowTooltip"
                            />
                            <TableRow
                                    :tableBody="tableBody"
                                    :tableHead="tableHead"
                                    :isHover="isHover"
                                    :allowTooltip="allowTooltip"
                                    :moreMode="moreMode"
                                    :isMapOpen="isMapOpen"
                                    :table-data="tableData"
                            />
                    </div>
                </transition>




            </div>

            <Pagination
                v-if="tableData.last_page > 1"
                class="table__navigation"
                :item="tableData"
                :request-function="requestFunction"
                :options="options"
            />

    </div>


</template>

<script>
    import TableRow from "./TableRow";
    import Pagination from "../Pagination";
    import TableHead from "./TableHead";
//    import TablePreloader from "./TablePreloader";
    // import MoreInfo from "./MoreInfo";

    export default {
        components: {
            TableHead,
            Pagination,
            TableRow,
//            TablePreloader
            // MoreInfo
        },

        props: {
            tableHead: {
                type: Array,
                required: true,
            },
            tableBody: {
                type: Array,
                required: true,
            },
            requestFunction: {
                type: Function,
                required: true,
            },
            tableData: {
                type: [Object, Array],
                required: true,
            },
            allowTooltip: {
                type: Boolean,
                default: false
            },
            isHover: {
                type: Boolean,
                default: false
            },
            moreMode: {
                type: String,
                required: true,
            },
            isMapOpen: {
                type: Boolean,
                required: false,
                default: false,
            },
            options: {
                type: Object,
                required: false,
                default: null,
            }
        },
        computed: {
          getLoader() {
              return this.$store.getters.getLoader
          },
          emptyText() {
              return this.$t(`table.table_empty.${this.$route.name}`);
          },
        },
        beforeDestroy() {
            this.$store.commit('UNSET_TABLE_DATA');
            this.$store.commit('CLOSE_MODAL');
        }
    }
</script>

<style lang="sass" scoped>
    .table
        margin-top: 16px
        position: relative
        &__container,
        &__empty
            background-color: $color--white
            box-shadow: 0 16px 20px rgba(11, 35, 75, 0.1)
            border-radius: 4px
            height: 100%
        &__container
            position: relative
            z-index: 1
        &__empty
            padding: 64px 0
            &-pic
                max-width: 200px
                max-height: 200px
            &-text
                font-size: 24px
                +semi
                letter-spacing: 1px
                margin-top: 24px
                color: $color--dark-lighten
                +r(599)
                    text-align: center
        &__navigation
            margin-top: 40px



    .table-view-enter,
    .table-view-leave-to
        opacity: 0
        transform: translateY(-20px)
    .table-view-move
        transition: transform .4s, opacity .4s
    .table-view-leave-active,
    .table-view-enter-active
        transition: 0.5s


</style>